/**
 * AvatarGroup - renders a contact avatar with an optional overlaid user avatar.
 * Used in DetailHeaderContact to show contact photo + cadence owner.
 */

import type { ReactNode } from 'react';

import Avatar from '../Avatar/Avatar';
import TeamUserAvatar from '../Avatar/TeamUserAvatar';
import Tooltip from '../Input2/Tooltip';

export type AvatarGroupProps = {
  /** URLs for the main contact avatar */
  avatarUrls: (string | null | undefined)[];
  /** Alt text for the main avatar */
  avatarAlt: string;
  /** Cadence owner user data (renders small overlaid avatar) */
  cadenceContactUser?: {
    userId: string;
    profilePicture?: string | null;
    userTeamName?: string | null;
    userEmail: string;
  } | null;
  /** Whether the contact is connected on LinkedIn */
  isConnected?: boolean;
  /** Tooltip label for the user avatar */
  userTooltipLabel?: string;
  /** Additional content to render after the avatars */
  children?: ReactNode;
};

export default function AvatarGroup({
  avatarUrls,
  avatarAlt,
  cadenceContactUser,
  isConnected,
  userTooltipLabel,
}: AvatarGroupProps) {
  return (
    <>
      <Avatar
        srcs={avatarUrls.filter(Boolean) as string[]}
        alt={avatarAlt}
        shape="circle"
        className="size-10"
        coloredBackground
      />
      {cadenceContactUser && (
        <Tooltip tooltip={userTooltipLabel}>
          <TeamUserAvatar
            connected={isConnected}
            userTeam={cadenceContactUser}
            className="absolute bottom-0 left-0 size-3.5"
            shape="circle"
          />
        </Tooltip>
      )}
    </>
  );
}
